export enum ProjectOverviewActionType {
    GET_INVOLVED_PROJECTS = 'GET_INVOLVED_PROJECTS',
    WITHDRAW_PROJECT = 'WITHDRAW_PROJECT',
}
